import React, {useEffect, useState} from 'react'
import {Alert} from 'antd'
import gql from 'graphql-tag'
import {useLazyQuery, useMutation} from '@apollo/react-hooks'

import UpsellView from 'components/shared/UpsellView'

interface Props {
  estate: any
  refetch(): any
  customerSpecificPriceListUrl?: string
}

const addUpsellOrderMutation = gql`
  mutation AddUpsellOrder($input: AddUpsellOrderInput!) {
    AddUpsellOrder(input: $input) {
      order {
        id
      }
    }
  }
`

export const previewOrderBillQuery = gql`
  query PreviewOrderBillQuery($estateId: ID!, $products: [String]) {
    estate(id: $estateId) {
      id
      previewOrderBill(products: $products) {
        sumIncVat
      }
    }
  }
`

function createAvailableProductsList(availableProducts: any[] = []) {
  let products: any[] = []
  availableProducts.forEach(availableProduct => {
    switch (availableProduct.__typename) {
      case 'VideoProduct':
        break

      case 'StylingProduct':
        products.push({
          ...availableProduct,
          name: 'Boligstyling Plus',
          plus: true,
        })
        break

      case 'FloorPlansProduct':
        products.push({
          ...availableProduct,
          measurement: true,
          unlimited: true,
          floors: 1,
        })
        break

      default:
        const toMerge: any = {}
        if (availableProduct.minQuantity) {
          toMerge.quantity = availableProduct.minQuantity
        }
        products.push({
          ...availableProduct,
          ...toMerge,
        })
    }
  })

  return products
}

function OtherBookingsUpsell({ estate, refetch, customerSpecificPriceListUrl }: Props) {
  const availableProducts = estate.availableProducts.edges.map(({node}: any) => node)
  const products = createAvailableProductsList(availableProducts)
  const estateId = estate.id

  const [submitSuccessful, setSubmitSuccessful] = useState(false)
  const [previewQuery, {loading: previewLoading, data: previewData}] = useLazyQuery(previewOrderBillQuery)
  const [mutation, {loading: isSubmitting, data: mutationData, error: mutationError}] = useMutation(addUpsellOrderMutation)

  useEffect(() => {
    if (mutationData) {
      refetch()
      setSubmitSuccessful(true)
    }
  }, [mutationData, refetch])

  function previewOrderBill(products = []) {
    if (!customerSpecificPriceListUrl) {
      return previewQuery({variables: {estateId, products}})
    }
  }

  function addUpsellOrder(
    products: string[],
    approval: any,
    preferredResourceDateTime?: any,
    messageForCustomerService?: string
  ) {
    setSubmitSuccessful(false)
    return mutation({
      variables: {
        input: {
          estateId,
          products,
          approval,
          preferredResourceDateTime,
          messageForCustomerService,
        },
      },
    })
  }

  return (
    <>
      {mutationError && (
        <div className="section error">
          <Alert
            type="error"
            message="En feil oppstod ved opprettelse av ordren. Vennligst forsøk på nytt eller kontakt EFKT kundeservice."
          />
        </div>
      )}
      {submitSuccessful && (
        <div className="section receipt">
          <Alert
            type="success"
            message="Mersalget er registrert!"
          />
        </div>
      )}
      {!submitSuccessful && (
        <UpsellView
          customerSpecificPriceListUrl={customerSpecificPriceListUrl}
          brokerPhone={estate.broker.phone}
          enableComments={true}
          products={products}
          previewOrderBill={previewData && previewData.estate ? previewData.estate.previewOrderBill : {}}
          fetchPreviewOrderBill={previewOrderBill}
          loading={previewLoading}
          addUpsellOrder={addUpsellOrder}
          isSubmitting={isSubmitting}
        />
      )}
    </>
  )
}

export default OtherBookingsUpsell
